export * from './notification-badge'



// WEBPACK FOOTER //
// ./src/app/shared/components/notification-badge/index.ts